<!--
 * @Descripttion: 
 * @Version: 1.0
 * @Author: zyh
 * @Date: 2024-07-29 16:05:04
 * @LastEditors: zyh
 * @LastEditTime: 2024-09-12 16:20:03
-->
<template>
    <div class="p-wrapper">
        <van-popup v-model="myShow"
                   closeable
                   :style="{ height: '350px' }"
                   position="bottom">
            <div class="content">
                <p class="title">处方筛选</p>
                <div class="real-content">
                    <p class="name">按时间</p>
                    <div class="type-box">
                        <span @click="clickQuickType(index)"
                              class="type"
                              :class="{'active':selIndex == index}"
                              v-for="(text,index) in dateTextArr"
                              :key="index">{{text}}</span>
                    </div>
                    <!-- <p class="name">自定义选择</p> -->
                    <div class="start-end-content">
                        <button :class="{'active':startTime}"
                                @click="clickSelectTime('start')"> {{startTime || '开始时间' }} </button>
                        <span class="line"></span>
                        <button :class="{'active':endTime}"
                                @click="clickSelectTime('end')">{{endTime || '结束时间' }} </button>
                    </div>
                </div>
                <div class="bottom">
                    <van-button class="reset-btn c-btn"
                                @click="handleClick('reset')">重置</van-button>
                    <van-button :disabled="!sureBtnActive"
                                class="sure-btn c-btn"
                                @click="handleClick('sure')">确定</van-button>
                </div>
            </div>
        </van-popup>
        <div style="paddin:10px 0">
            <van-popup v-model="showcDatePicker"
                       :style="{ height: '350px' }"
                       position="bottom">
                <van-datetime-picker v-model="currentDate"
                                     type="date"
                                     title="选择日期"
                                     :min-date="minDate"
                                     :max-date="maxDate"
                                     :formatter="formatter"
                                     @confirm="onConfirmDate"
                                     @cancel="showcDatePicker=false" />
            </van-popup>
        </div>
    </div>
</template>

<script>

import { formatDate } from '@/utils/index'
import { toast } from '@/components/Toast'

function getDates (daysBehind = 0) {
    const today = new Date();
    const pastDate = new Date(today);
    pastDate.setDate(today.getDate() - daysBehind);

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    return {
        today: formatDate(today),
        pastDate: formatDate(pastDate)
    };
}

function areDatesMoreThan366DaysApart(start, end) {
    // 计算两个日期之间的差值（毫秒）
    const timeDiff = end - start;
    // 将毫秒转为天数
    const daysDiff = timeDiff / (1000 * 60 * 60 * 24);
    return daysDiff > 366;
}
export default {
    props: {
        isShow: {
            type: Boolean,
            default: false,
        },

    },
    data () {
        return {
            dateTextArr: ['7天内', '30天内', '90天内'],
            selIndex: -1,

            curTimeType: '',
            startTime: '',
            endTime: '',

            minDate: new Date(2020, 0, 1),
            maxDate: new Date(2030, 12, 30),
            currentDate: new Date(),

            showcDatePicker: false,
        }
    },
    created () {
        const today = new Date();
        // 获取三年前的日期
        this.minDate = new Date(today.getFullYear() - 3, today.getMonth(), today.getDate());
        this.maxDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    },
    mounted () { },
    methods: {
        formatter (type, val) {
            if (type === 'year') {
                return `${val}年`;
            } else if (type === 'month') {
                return `${val}月`;
            }
            return `${val}日`;
        },
        clickQuickType (index) {
            this.selIndex = index;
            const dateMap = {
                0: 6,
                1: 29,
                2: 89,
            }
            const dateObj = getDates(dateMap[index])
            this.endTime = dateObj.today;
            this.startTime = dateObj.pastDate;
        },
        clickSelectTime (type) {
            this.selIndex = -1;
            this.curTimeType = type;
            if (type == 'end') {
                if (!this.startTime) return this.$toast('请先选择开始时间');
            }
            this.showcDatePicker = true;
        },
        onConfirmDate (value) {
            const timeStr = formatDate(value, 'yyyy-MM-dd');
            this.curTimeType == 'start' ? this.startTime = timeStr : this.endTime = timeStr;
            const startDate = new Date(this.startTime);
            const endDate = new Date(this.endTime);
            if (startDate > endDate) {
                this.endTime = '';
                return this.$toast('开始时间不能大于结束时间');
            }
            if(areDatesMoreThan366DaysApart(startDate, endDate)) {
                 this.endTime = '';
                return this.$toast('时间筛选跨度不超过366天');
            }
            this.showcDatePicker = false;
        },
        handleClick (type) {
            if (type == 'sure') {
                if (this.selIndex == -1 && !this.curTimeType) return this.$toast('请选择筛选日期');
                if (this.selIndex == -1) {
                    if (!this.startTime || !this.endTime) return this.$toast('请选择完整的日期区间');
                }
                this.$emit('update:isShow', false);
                this.$emit('filterCallback', {
                    inquiryReportStartTime: this.startTime,
                    inquiryReportEndTime: this.endTime,
                    inquiryReportTimeSearchType: this.selIndex + 1, //inquiryReportTimeSearchType (1 : 7天 , 2 : 30天 , 3 : 90天)
                })
            } else {
                this.$emit('update:isShow', false);
                this.selIndex = -1;
                this.startTime = this.endTime = '';
                this.$emit('filterCallback');
            }
        }
    },
    computed: {
        myShow: {//双向传值
            set (val) {
                this.$emit('update:isShow', val);
            },
            get () {
                return this.isShow;
            }
        },
        sureBtnActive () {
            return this.selIndex > -1 || this.startTime || this.endTime
        },
    },
}
</script>
<style lang='scss' scoped>
/deep/ .van-picker__toolbar {
    height: 50px;
    .van-picker__cancel,
    .van-picker__title,
    .van-picker__confirm {
        font-size: 18px;
    }
    .van-picker__confirm {
        color: #24af41;
    }
}
.p-wrapper {
    .content {
        height: 100%;
        .title {
            font-weight: 500;
            font-size: 18px;
            text-align: center;
            padding: 15px 0 0;
        }
        .real-content {
            height: 60%;
            padding: 20px 20px 5px 20px;
            .name {
                padding-bottom: 5px;
                font-weight: 500;
                font-size: 16px;
                color: #666666;
            }
            .type-box {
                display: flex;
                margin: 10px 0 20px;
                .type {
                    margin-right: 5%;
                    width: 33%;
                    border: 1px solid #c9c9c9;
                    font-size: 16px;
                    text-align: center;
                    height: 35px;
                    line-height: 35px;
                    border-radius: 17px;
                    &.active {
                        border: 1px solid #24af41;
                        color: #24af41 !important;
                    }
                }
            }
            .start-end-content {
                margin-top: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                .line {
                    width: 30px;
                    margin: 0 10px;
                    height: 1px;
                    background-color: #c9c9c9;
                }
                button {
                    background-color: white;
                    border: none;
                    font-size: 16px;
                    padding: 8px 24px;
                    border-radius: 4px;
                    border: 1px solid #c3c3c3;
                    color: #c9c9c9;
                    &.active {
                        color: #333333;
                    }
                }
            }
        }
        .bottom {
            text-align: center;
            .c-btn {
                border: none;
                height: 44px;
                font-size: 18px;
                width: 100px;
                border-radius: 22px;
            }
            .reset-btn {
                background: #f8faf9;
                color: #999999;
                margin-right: 40px;
            }
            .sure-btn {
                background: linear-gradient(90deg, #24af41 0%, #8dd84a 100%);
                color: white;
            }
        }
    }
}
</style>

